/*
 * @Author: your name
 * @Date: 2021-09-01 20:14:14
 * @LastEditTime: 2021-09-10 19:21:31
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \mms\src\utils\oss.js
 */
import OSS from 'ali-oss'
import * as imageConversion from 'image-conversion'
import { service } from '@/utils/request'

export default function ossUpload (files) {
  return new Promise(async (resolve, reject) => {
    try {
      const config = await getConfig()
      const client = new OSS({
        region: 'oss-cn-beijing',
        bucket: process.env.VUE_APP_BUCKET,
        ...config
      })
      let i = 0
      // 上传多张图片待测试
      if (Array.isArray(files)) {
        const promiseAll = []
        for (let file of files) {
          if (file.type.includes('image/')) {
            await compressImg(file, 1024 * 1024).then(comFile => {
              promiseAll.push(client.put(getObjectKey(file.name), comFile))
            })
          } else {
            promiseAll.push(client.put(getObjectKey(file.name), file))
          }
          if (i === files.length - 1) {
            const arrResult = await Promise.all(promiseAll)
            const uploadSuccess = arrResult.filter((x, i) => {
              x.fileLocalName = files[i].name
              return x.res.status === 200 && x.res.statusCode === 200
            })
            if (uploadSuccess.length) {
              resolve(uploadSuccess.map(x => {
                return {
                  url: x.name,
                  name: x.fileLocalName
                }
              }))
            } else {
              reject(new Error('上传失败'))
            }
          }
          i = i + 1
        }
      } else {
        const { res, name } = await client.put(getObjectKey(files.name), files)
        if (res.status === 200 && res.statusCode === 200) {
          resolve(name)
        } else {
          reject(new Error('上传失败'))
        }
      }
    } catch (e) {
      console.error('e', e)
      reject(e)
    }
  })
}

function getObjectKey (fileName) {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const timestampReverse = String(date.getTime()).split('').reverse().join('')
  return `upload/${year}/${month}/${day}/${randomString()}${timestampReverse}.${fileName.substring(fileName.lastIndexOf('.') + 1)}`
}
async function compressImg (file, limit) {
  return new Promise((resolve) => {
    if (file.size > limit) {
      imageConversion.compress(file, 0.5).then(res => {
        resolve(res)
      })
    } else {
      resolve(file)
    }
  })
}
async function getConfig () {
  const configCookie = getCookie('oss')
  if (configCookie) {
    const [accessKeyId, accessKeySecret, stsToken] = configCookie.split(',')
    return {
      accessKeyId,
      accessKeySecret,
      stsToken
    }
  } else {
    const { code, data } = await service.get('/oss/token')
    if (code === '00000') {
      setCookie('oss', `${data.accessKeyId},${data.accessKeySecret},${data.securityToken}`, data.expiration)
      return {
        accessKeyId: data.accessKeyId,
        accessKeySecret: data.accessKeySecret,
        stsToken: data.securityToken
      }
    } else {
      throw new Error('oss配置参数获取失败')
    }
  }
}

function setCookie (name, value, expires) {
  const exp = new Date(expires)
  document.cookie = `${name}=${escape(value)};expires=${exp.toGMTString()};path=/`
}

function getCookie (name) {
  let result = document.cookie.match('(^|[^;]+)\\s*' + name + '\\s*=\\s*([^;]+)')
  return result ? unescape(result.pop()) : ''
}

function randomString (length = 4) {
  let result = ''
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  for (let i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }
  return result
}
